import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Home from './pages/Home';
import Search from './pages/Search';
import FindProperty from './pages/FindProperty';
import Area from './pages/Area';
import ListingDetail from './pages/ListingDetail';
import BookingCheckout from './pages/BookingCheckout';
import BookingConfirmation from './pages/BookingConfirmation';
import Account from './pages/Account';
import Bookings from './pages/Bookings';
import Login from './pages/Login';
import Register from './pages/Register';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
// Admin pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminListings from './pages/admin/Listings';
import AdminListingEditor from './pages/admin/ListingEditor';
import AdminCalendarEditor from './pages/admin/CalendarEditor';
import AdminBookings from './pages/admin/Bookings';
import AdminUsers from './pages/admin/Users';
import AdminSettings from './pages/admin/Settings';
import WPRentalsImport from './pages/admin/WPRentalsImport';
import PayFastCheckout from './pages/PayFastCheckout';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public routes */}
          <Route index element={<Home />} />
          <Route path="search" element={<Search />} />
          <Route path="find-property" element={<FindProperty />} />
          <Route path="areas/:citySlug" element={<Area />} />
          <Route path="listing/:idOrSlug" element={<ListingDetail />} />
          <Route path="p/:slug" element={<ListingDetail />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="payfast-checkout" element={<PayFastCheckout />} />
          
          {/* Protected user routes */}
          <Route
            path="booking/:id/checkout"
            element={
              <ProtectedRoute>
                <BookingCheckout />
              </ProtectedRoute>
            }
          />
          <Route
            path="booking/:id/confirmation"
            element={
              <ProtectedRoute>
                <BookingConfirmation />
              </ProtectedRoute>
            }
          />
          <Route
            path="account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="bookings"
            element={
              <ProtectedRoute>
                <Bookings />
              </ProtectedRoute>
            }
          />

          {/* Admin routes (RBAC protected) - uses separate layout */}
          <Route
            path="admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="listings" element={<AdminListings />} />
            <Route path="listings/new" element={<AdminListingEditor />} />
            <Route path="listings/:id" element={<AdminListingEditor />} />
            <Route path="listings/:id/calendar" element={<AdminCalendarEditor />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="import/wp-rentals" element={<WPRentalsImport />} />
          </Route>

          {/* Short property URLs: /bronze-bay-17 (must stay below static routes) */}
          <Route path=":listingSlug" element={<ListingDetail />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;

